import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';


@Component({
    selector: 'support-customers',
    templateUrl: './support-customers.component.html',
    styleUrls: ['./support-customers.component.scss'],
    providers: [MessageService]
})
export class SupportCustomersComponent implements OnInit {
    public selectedDateRange: Date[] = [];

    ngOnInit(): void {
        this.selectedDateRange[1] = new Date();
        this.selectedDateRange[0] = new Date();
        this.selectedDateRange[0].setDate(new Date().getDate() - 30);
    }
}
